import { clearOptions } from "../../Utilities/Platform/Options/Options";
import { sendServiceWorkerMessage } from "../../Utilities/Platform/ServiceWorkerHelper";
import { sendSecurityEvent } from "../../Workers/Upload/UploadAgent";
import { determineDataSource } from "./DataSource";

export async function clearLocalData(): Promise<void> {
    if(typeof localStorage !== "undefined") {
        clearOptions();
    }

    await sendSecurityEvent("CLEAR_DATA", {});

    const promises = [];

    promises.push(sendServiceWorkerMessage("CLEAR_CACHE"));
    promises.push(async () => {
        // Clear the origin private file system
        if("remove" in FileSystemFileHandle.prototype) {
            const fileSystemRoot = await navigator.storage.getDirectory();

            await (fileSystemRoot as unknown as { remove: (options: { recursive: boolean; }) => Promise<void>; })
                .remove({
                    recursive: true,
                });
        }
    });
    promises.push(
        determineDataSource()
            .then(source => {
                return source.clearDatabase();
            })
    );

    Promise.all(promises)
        .finally(() => {
            location.reload();
        });
}
